module.exports = __webpack_public_path__ + "static/media/chia_ying_yang.556cd611.jpg";